/**
 * Landing-page sticky mobile CTA bar.
 *
 * Reveals the fixed bottom CTA ([data-lp-sticky]) once the hero form has
 * scrolled out of view, and hides it again over the footer. A no-op on pages
 * without the sticky element. Shared by every landing-page hero variant.
 */
document.addEventListener('DOMContentLoaded', () => {
	const sticky = document.querySelector('[data-lp-sticky]')

	if (!sticky) {
		return
	}

	const form = document.getElementById('form')
	const footer = document.querySelector('footer')

	const updateSticky = () => {
		let formVisible = false
		let footerVisible = false

		if (form) {
			const formRect = form.getBoundingClientRect()
			formVisible = formRect.top < window.innerHeight && formRect.bottom > 0
		}

		if (footer) {
			footerVisible = footer.getBoundingClientRect().top <= window.innerHeight
		}

		const showSticky = !formVisible && !footerVisible

		if (showSticky) {
			sticky.inert = false
			sticky.removeAttribute('aria-hidden')
			sticky.classList.remove('tw-translate-y-full', 'tw-opacity-0')
			sticky.classList.add('tw-translate-y-0', 'tw-opacity-100', 'tw-pointer-events-auto')
		} else {
			sticky.inert = true
			sticky.setAttribute('aria-hidden', 'true')
			sticky.classList.add('tw-translate-y-full', 'tw-opacity-0')
			sticky.classList.remove('tw-translate-y-0', 'tw-opacity-100', 'tw-pointer-events-auto')
		}
	}

	window.addEventListener('scroll', updateSticky, { passive: true })
	window.addEventListener('resize', updateSticky)
	updateSticky()
})
